import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import PropTypes from 'prop-types';

export default function DropdownSp(props) {
  DropdownSp.propTypes = {
    required: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  DropdownSp.defaultProps = {
    required: false,
    className: '',
    disabled: false,
  };

  const { required, className, disabled, ...rest } = props;

  const classNames = required && !disabled ? `p-error ${className || ''}` : className || '';
  return <Dropdown {...rest} disabled={disabled} className={classNames} />;
}
